var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 30",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FD6A7E;}\r\n\t.st1{fill:#17B978;}\r\n\t.st2{fill:#8797EE;}\r\n\t.st3{fill:#41A6F9;}\r\n\t.st4{fill:#37E0FF;}\r\n\t.st5{fill:#2FD9B9;}\r\n\t.st6{fill:#F498BD;}\r\n\t.st7{fill:#FFDF1D;}\r\n\t.st8{fill:#C6C9CC;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,5H4C3.4,5,3,5.4,3,6v12c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V6C27,5.4,26.6,5,26,5z M5.5,14  c-0.2,0-0.4,0-0.5,0.1V9.9C5.1,10,5.3,10,5.5,10C6.9,10,8,8.9,8,7.5C8,7.3,8,7.1,7.9,7h14.1C22,7.1,22,7.3,22,7.5  c0,1.4,1.1,2.5,2.5,2.5c0.2,0,0.4,0,0.5-0.1v4.1c-0.1,0-0.3-0.1-0.5-0.1c-1.4,0-2.5,1.1-2.5,2.5c0,0.2,0,0.4,0.1,0.5H7.9  C8,16.9,8,16.7,8,16.5C8,15.1,6.9,14,5.5,14z M12,12c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3S12,13.7,12,12z M5,22v-1h20v1  c0,0.6-0.4,1-1,1H6C5.4,23,5,22.6,5,22z M7.4,26v-1h15v1c0,0.6-0.4,1-1,1h-13C7.8,27,7.4,26.6,7.4,26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.97d6db09f80d663490a0d516d92dda65.svg";
export { ForwardRef as ReactComponent };